module.exports = __webpack_public_path__ + "block-1-1x-b3824ffc714c539630ba24515298a4e9.webp";